// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttonGroup":"group-gift-goal-amount-form__buttonGroup__1zsr5","customLink":"group-gift-goal-amount-form__customLink__2dtpO"};